import TeacherLandingModule from './containers/teacherLandingModule'

export {default as TeacherLandingModuleLayout} from './components/teacherLandingModuleLayout'

export default TeacherLandingModule
